import { useEffect, useRef } from "react";

export function useOnMounted(callback: () => void) {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      callback();
    }
  }, [callback]);
}
